import React, { useCallback, useEffect, useState } from 'react'
import {
  View,
  Text,
  ActivityIndicator,
  StyleSheet,
  ScrollView
} from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigation, useRoute } from '@react-navigation/native'

import AddNewIssueModal from '../../../components/maintainance/AddNewIssueModal'

import {
  getFlow,
  getRoomTypes,
  getCatogoriesTypes,
  getProjects,
  updateIssueStatus,
  updateProject,
} from '../../../redux/action/maintenance.actions'

import { showErrorToast, showSuccesToast } from '../../tenants/tenantOnboarding/helpers'
import drawerHoc from '../../../components/drawerHOC/DrawerHOC'
import ActiveProjectIssueTable from './ActiveProjectIssueTable'
import CommonModal from '../../../components/maintainance/CommonModal'
import ProjectHeaderCard from '../../../components/maintainance/ProjectHeaderCard'
import Timeline from '../../../components/maintainance/Timeline'
import HeaderWithBack from '../../../components/maintainance/HeaderWithBack'
import TableShimmer from '../../../components/maintainance/TableShimmer'
interface IssueType {
  open_flow_maintenance_issue_id: number
  [key: string]: any
}
interface ProjectIssuesType {
  total?: number,
  comments: any[],
  issues?: IssueType[]
}
interface ProjectDetailsProps {
  project_id?: number,
  onBack?: () => void,
  onProjectCompleted?: (data: any) => void,
  type_props?: string
}
const Active_project_openflow_id = ({ project_id: propProjectId, type_props, onBack }: ProjectDetailsProps) => {

  const route = useRoute()
  const openflow_id = propProjectId ?? route?.params?.id
  const type = type_props ?? route?.params?.type

  console.log("typetype", type)
  const navigation = useNavigation()
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [flowData, setFlowData] = useState<any>(null)
  const [issues, setIssues] = useState<IssueType[]>([])
  const [selectedStatus, setSelectedStatus] = useState<string>('')
  const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false)
  const [selectedIssue, setSelectedIssue] = useState<IssueType | null>(null)
  const [showCompleteProjectModal, setShowCompleteProjectModal] = useState(false)
  /* ---------------- FETCH FLOW ---------------- */
  const { projecIssuetList } = useSelector(
    (state) => state.maintenance
  )
  useEffect(() => {
    setFlowData(projecIssuetList)
  }, [projecIssuetList])
  const fetchFlow = useCallback(async () => {
    try {
      setLoading(true)

      await dispatch(
        getProjects({
          flow_id: Number(openflow_id),
        })
      )

    } catch (error) {
      showErrorToast('Failed to fetch flow')
    } finally {
      setLoading(false)
    }
  }, [dispatch, openflow_id])

  useEffect(() => {
    dispatch(getRoomTypes())
    dispatch(getCatogoriesTypes())
  }, [dispatch])

  useEffect(() => {
    if (openflow_id) {
      fetchFlow()
    }
  }, [fetchFlow])

  const handleView = (issue: any) => {
    navigation.navigate('IssueDetails', {
      id: issue?.open_flow_maintenance_issue_id
    })
  }


  const handleUpdateIssueStatus = async () => {
    if (selectedIssue && selectedIssue.open_flow_maintenance_issue_id) {
      setLoading(true)
      setShowUpdateStatusModal(false)
      await dispatch(updateIssueStatus({ project_id: Number(openflow_id), status: selectedStatus, issue_id: selectedIssue.open_flow_maintenance_issue_id }))
      setLoading(false)
      setSelectedIssue(null)
      setSelectedStatus('')
    }
  }
  const handleProjectComplete = () => {
    const notCompletedIssues = flowData?.issues.filter((issue: any) => issue.status !== 'completed')
    console.log("flowDataflowData", notCompletedIssues)
    if (notCompletedIssues?.length > 0) {
      showErrorToast("All individual issues needs to be closed first before completing project")
    } else {
      setShowCompleteProjectModal(true)
    }
  }
  const handleProjectComplete1 = async () => {
    await dispatch(updateProject({ project_id: Number(openflow_id), status: 'completed' }, (result) => {
      showSuccesToast("Project completed successfully!")
      if(propProjectId){
        onBack("completed")
      }else{
        navigation.navigate('CompletedProject', {
          id: "completed",
        })
      }
    }))

    setShowCompleteProjectModal(false)

  }

  return (
    <ScrollView style={styles.container}>
      {propProjectId?<HeaderWithBack
        onPress={() => {
          onBack()
        }}
      />:null}
     {flowData?.displayAddress? <ProjectHeaderCard
        title={flowData?.title ? flowData?.title : "-"}
        address={flowData?.displayAddress}
        status={flowData?.status}
        onComplete={handleProjectComplete}
        themeColor="#2563EB"
        type={type}
      />:null}
{loading?    <TableShimmer rows={6} />:
<ActiveProjectIssueTable
        type={type}
        flos={flowData?.issues || []}
        flototal={flowData?.issues?.length || 0}
        page={0}
        pageSize={10}
        onPageChange={() => { }}
        onPageSizeChange={() => { }}
        onView={handleView}
        refresh={fetchFlow}
        onAdd={() => setOpenModal(true)}
        openflow_id={openflow_id}
        updateIssueStatus={(row: IssueType, status: string) => {
          setSelectedIssue(row)
          setSelectedStatus(status)
          setShowUpdateStatusModal(true)
        }}

      />
}
      
      {flowData?.comments && flowData?.comments?.length ? <Timeline data={flowData?.comments} /> : null}

      <CommonModal
        visible={showUpdateStatusModal}
        heading="Update Issue Status"
        subheading="Are you sure you want to update this issue?"
        yesText="Yes, Update"
        noText="Cancel"
        onNo={() => setShowUpdateStatusModal(false)}
        onYes={handleUpdateIssueStatus}
      />
      <CommonModal
        visible={showCompleteProjectModal}
        heading="Are you sure?"
        subheading="Are you sure, You want to complete this project?"
        yesText="Yes, Complete"
        noText="Cancel"
        onNo={() => setShowCompleteProjectModal(false)}
        onYes={handleProjectComplete1}
      />


    </ScrollView>
  )
}

const WrappedComponent = drawerHoc({
  Component: Active_project_openflow_id,
  showBackButton: true,
  customWidth: "70%",
})


export default function ExportComponent(props: any) {
  if (props?.project_id) {
    return <Active_project_openflow_id {...props} />
  }
  return <WrappedComponent {...props} />
}

const styles = StyleSheet.create({
  subHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 14,
    marginTop: 10,
  },

  subTitle: {
    fontSize: 15,
    fontWeight: "700",
    color: "#111827",
  },

  subBadge: {
    marginLeft: 10,
    backgroundColor: "#E9D8F7",
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 20,
  },

  subBadgeText: {
    color: "#6D08C0",
    fontSize: 12,
    fontWeight: "600",
  },

  divider: {
    height: 1,
    backgroundColor: "#F3F4F6",
    marginVertical: 20,
  },

  cardGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
  },

  cardWrapper: {
    width: 320,
    marginRight: 16,
    marginBottom: 16,
  },

  container: {
    flex: 1,

  },

  center: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },

  address: {
    fontSize: 20,
    fontWeight: '700',
    color: '#6D08C0',
    marginBottom: 25,
  },

  section: {
    marginBottom: 30,
  },

  sectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    marginBottom: 15,
    color: '#111827'
  },

})
